// export default {
//   name: "Dashboard",
//   path: "/dashboard",
//   meta: {
//     icon: "dashboard",
//     auth: true
//   },
//   departmentName: "Dashboard",
//   finalPagePermision: "",

//   component: require("../component/view/dashboard/dashboard.vue")
// };

export default {
  name: "Dashboard",
  meta: {
    icon: "dashboard",
    expanded: true,
    auth: true,
  },
  departmentName: "Dashboard",
  finalPagePermision: "",
  children: [
    // {
    //     name: "Pridel Document",
    //     permissionName: 'Pridel Document',
    //     keywords: ['Pridel Document'],
    //     path: "/DocumentValidator",
    //     meta: {
    //         icon: "dashboard",
    //         auth: true,
    //     },
    //     component: require("../component/masters/documentValidatorMaster.vue"),
    //     finalPagePermision: "Pridel Document",
    // },
    {
      name: "Dashboard",
      path: "/dashboard",
      permissionName: "Sea Export",
      keywords: ["Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/view/dashboard/dashboard.vue"),
      finalPagePermision: "",
    },
    {
      name: "Volume Dashboard",
      path: "/volumeDash",
      permissionName: "Sea Export",
      keywords: ["Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/tuesVolumeCard.vue"),
      finalPagePermision: "",
    },
    {
      name: "TPT Dashboard",
      path: "/TPTdashboard",
      permissionName: "TPT_Dashboard",
      keywords: ["TPT Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/tptDashboard.vue"),
      finalPagePermision: "TPT_Dashboard",
    },
    {
      name: "FF Exp Dashboard",
      path: "/ffseaExpdashboard",
      permissionName: "FF_Exp_Dashboard",
      keywords: ["FF Exp Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/ffDashboard.vue"),
      finalPagePermision: "FF_Exp_Dashboard",
    },
    {
      name: "Growth Dashboard",
      path: "/dashboard/analysisDashboard",
      permissionName: "Analysis_Dashboard",
      keywords: ["Growth Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/analysisDashboard.vue"),
      finalPagePermision: "Analysis_Dashboard",
    },
    {
      name: "Growth Dashboard New",
      path: "/dashboard/growth-dashboard-new",
      permissionName: "Analysis_Dashboard",
      keywords: [
        "Growth Dashboard",
        "Monthly Growth",
        "Client Analysis",
        "Shipping Line Analysis",
        "Branch Analysis",
        "Branch Monthly",
      ],
      meta: {
        icon: "line-chart",
        auth: true,
      },
      component: require("../component/dashboard/growthDashboard.vue"),
      finalPagePermision: "Analysis_Dashboard",
    },
    {
      name: "Outstanding Dashboard",
      path: "/dashboard/ledger-outstanding-dashboard",
      permissionName: "Analysis_Dashboard",
      keywords: [
        "Ledger Outstanding",
        "Client-wise",
        "Agent-wise",
        "Branch-wise",
        "Shipping Line-wise",
      ],
      meta: {
        icon: "line-chart",
        auth: true,
      },
      component: require("../component/dashboard/ledgerOutstandingDashboard.vue"),
      finalPagePermision: "Analysis_Dashboard",
    },
    {
      name: "Rate List Dashboard",
      path: "/dashboard/rateList",
      permissionName: "",
      keywords: ["Rate List Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/rateListDashboard.vue"),
      finalPagePermision: "",
    },
    {
      name: "Vehicle Performance Dash",
      path: "/dashboard/vehiclePerformance",
      permissionName: "",
      keywords: ["Vehicle Performance", "Trips", "Maintenance"],
      meta: {
        icon: "local_shipping",
        auth: true,
      },
      component: require("../component/dashboard/VehiclePerformanceDashboard/VehiclePerformanceDash.vue"),
      finalPagePermision: "",
    },
    {
      name: "Timeline Dashboard",
      path: "/dashboard/timelineDashboard",
      permissionName: "",
      keywords: ["Timeline Dashboard"],
      meta: {
        icon: "local_shipping",
        auth: true,
      },
      component: require("../component/dashboard/timelineDashboard.vue"),
      finalPagePermision: "",
    },
    {
      name: "Sline FF EXP D/B",
      path: "/ffexpdash/ffExpSlinedash",
      permissionName: "Sline_FF_EXP_Dash",
      keywords: ["Sline FF EXP D/B"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/ffSlineDashboard.vue"),
      finalPagePermision: "Sline_FF_EXP_Dash",
    },
    {
      name: "POD Sline FF EXP D/B",
      path: "/podffExpSlinedash",
      permissionName: "Sline_FF_EXP_Dash",
      keywords: ["POD Sline FF EXP D/B"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/ffSlinePODDashboard.vue"),
      finalPagePermision: "Sline_FF_EXP_Dash",
    },
    // {
    //     name: "Purchase Dashboard",
    //     path: "/ffexpdash/purchase-dash",
    //     permissionName: '',
    //     keywords: ['Purchase Dashboard'],
    //     meta: {
    //         icon: "dashboard",
    //         auth: true,
    //     },
    //     component: require("../component/dashboard/purchaseDashboard.vue"),
    //     finalPagePermision: "",
    // },
    // {
    //     name: "Purchase Dashboard 2",
    //     path: "/ffexpdash/purchase-dash-2",
    //     permissionName: '',
    //     keywords: ['Purchase Dashboard 2'],
    //     meta: {
    //         icon: "dashboard",
    //         auth: true,
    //     },
    //     component: require("../component/dashboard/purchaseDashboardDetail.vue"),
    //     finalPagePermision: "",
    // },
    {
      name: "Client FF EXP D/B",
      path: "/ffexpdash/ffExpCleintdash",
      permissionName: "Client_FF_EXP_Dash",
      keywords: ["Client FF EXP D/B"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/ffClientDashboard .vue"),
      finalPagePermision: "Client_FF_EXP_Dash",
    },
    {
      name: "CSO Dashboard",
      path: "/pendClient",
      permissionName: "Client Sales Opportunity Dashboard",
      keywords: ["Client Job Pending"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/clientJob/Tab.vue"),
      finalPagePermision: "Client Sales Opportunity Dashboard",
    },
    {
      name: "Lead Dashboard",
      path: "/dashboard/leadDashboard",
      permissionName: "Lead_Dashboard",
      keywords: ["Lead Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/leadDashboard.vue"),
      finalPagePermision: "Lead_Dashboard",
    },

    {
      name: "Operational Dashboard",
      path: "/dashboard/optDashboard",
      permissionName: "Operational_Dashboard",
      keywords: ["Operational Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/optDashboard.vue"),
      finalPagePermision: "Operational_Dashboard",
    },
    // {
    //     name: "Assignment P&L Dashboard",
    //     path: "/P&LDashboard",
    //     permissionName: 'PL_Dashboard',
    //     keywords: ['Assignment P&L Dashboard'],
    //     meta: {
    //         icon: "dashboard",
    //         auth: true,
    //     },
    //     component: require("../component/dashboard/profitlossDashboard.vue"),
    //     finalPagePermision: "PL_Dashboard",
    // },
    {
      name: "Assignment P&L Dashboard New",
      path: "/pl_dash",
      permissionName: "PL_Dashboard",
      keywords: ["Assignment P&L Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/profitlossDashboardNew.vue"),
      finalPagePermision: "PL_Dashboard",
    },
    {
      name: "Email Details",
      path: "/EmailDetails",
      permissionName: "EmailDetails",
      keywords: ["Email Details"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      //component: require("../component/dashboard/email-section.vue"),
      component: require("../component/dashboard/email-details.vue"),
      finalPagePermision: "EmailDetails",
    },
    {
      name: "Email Section",
      path: "/EmailSection",
      permissionName: "EmailSection",
      keywords: ["Email Section"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/email-section.vue"),
      finalPagePermision: "EmailSection",
    },
    {
      name: "TPT GR Dashboard",
      path: "/TPTGRdashboard",
      permissionName: "TPT_GR_Dashboard",
      keywords: ["TPT GR Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/tptGRDashboard.vue"),
      finalPagePermision: "TPT_GR_Dashboard",
    },
    {
      name: "Billing Invoice Dashboard",
      path: "/billInvDash",
      permissionName: "Billing Invoice Dashboard",
      keywords: ["Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/billingInvDash.vue"),
      finalPagePermision: "Invoice Dashboard",
    },
    {
      name: "CTT Dashboard",
      path: "/tracking/ocean-insights",
      permissionName: "CTT Dashboard",
      keywords: ["CTT Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/ocean-insights/containerTrack.vue"),
      finalPagePermision: "CTT Dashboard",
    },
    {
      name: "Billing Rejection Dashboard",
      path: "/billRejectionDash",
      permissionName: "Bill Rejection Dash",
      keywords: ["Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/billingRejectionDash.vue"),
      finalPagePermision: "Bill Rejection Dash",
    },
    {
      name: "Billing Date Log",
      path: "/billDateLogDash",
      permissionName: "Billing Date Log",
      keywords: ["Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/billingDateLogDash.vue"),
      finalPagePermision: "Billing Date Log",
    },
    {
      name: "Contract Dashboard",
      path: "/contractDash",
      permissionName: "Contract Dash",
      keywords: ["Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/contractDashboard.vue"),
      finalPagePermision: "Contract Dash",
    },
    {
      name: "Lock Panel Dashboard",
      path: "/dash/lock-dash",
      permissionName: "Sea Export",
      keywords: ["Dashboard"],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/dashboard/lockPannelDash.vue"),
      finalPagePermision: "",
    },
    {
      name: "Sales Person Dashboard",
      // path: "/dashboard/sales-person-dashboard",
      path: "/dashboard/sales-person-teus-dashboard",
      permissionName: "Sales Person Dash",
      keywords: ["Sales Person Dashboard"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/SalesPersonTeusDashboard.vue"),
      finalPagePermision: "Sales Person Dash",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/sidebar/dashboard.js